import { spanishViridian500 } from '@habitech/shared';
import React from 'react';

const overlayStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(255,255,255,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
};

const spinnerStyle: React.CSSProperties = {
  border: '4px solid #f3f3f3',
  borderTop: `4px solid ${spanishViridian500}`,
  borderRadius: '50%',
  width: 40,
  height: 40,
  animation: 'spin 1s linear infinite',
};

export const LoadingOverlay: React.FC = () => (
  <div style={overlayStyle}>
    <div style={spinnerStyle} />
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}
    </style>
  </div>
); 